import { render, staticRenderFns } from "./RealtimeOnlines.vue?vue&type=template&id=236beb6b"
import script from "./RealtimeOnlines.vue?vue&type=script&lang=js"
export * from "./RealtimeOnlines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports